/**
 * Share
 * Opens the share window using the link's href and title attributes
 */
class Share {
    constructor(selector) {
        this.selector = selector;
        this.registerEvents();
    }

    /**
     * Register events
     */
    registerEvents() {
        document.body.addEventListener('click', delegate(this.selector, (e) => {
            let shareWindow = window.open(e.target.href, e.target.title, 'width=600, height=600, resizable, scrollbars, status');
            shareWindow.opener = null;
            e.preventDefault();
        }));
    }
}

new Share('[data-share]');
